import { adjust, amplitude } from '../adapters'

export default (wasLoggedIn: boolean) => {
  adjust.clearUser()
  // Anonymous visitors keep their device ID through flows that dispatch logOut.
  if (wasLoggedIn) amplitude.reset()
}
